import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { Text, IText } from 'app/constants/schemas/Text';
import { DialogSentenceQuiz, IDialogSentenceQuiz } from 'app/constants/schemas/DialogSentenceQuiz';
import { Sound, ISound } from 'app/constants/schemas/Sound';

export interface IDialogSentence extends IEntity {
  attributes: {
    id: EntityStringId;
    cohortId: string | null;
  };
  associations: {
    dialogSentenceQuizzes: IDialogSentenceQuiz[];
    text: IText;
    sound: ISound | null;
  };
}

export type DialogSentence = Entity<IDialogSentence>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DialogSentence: IEntityType<IDialogSentence> = vmClient.defineClass({
  typeName: 'DialogSentence',
  version: 4,
  lockable: true,
  persisted: true,
  attributes: {
    cohortId: 'string',
  },
  associations: {
    dialogSentenceQuizzes: {
      collection: true,
      type: DialogSentenceQuiz,
    },
    text: {
      type: Text,
      notNull: true,
    },
    sound: Sound,
  },
});
